/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Email_Invitation_MismatchInputs */

const es_co2_error_email_invitation_mismatch = /** @type {(inputs: Error_Email_Invitation_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El correo no coincide con el de la invitación.`)
};

/**

* @param {Error_Email_Invitation_MismatchInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_email_invitation_mismatch = /** @type {((inputs?: Error_Email_Invitation_MismatchInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Email_Invitation_MismatchInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_email_invitation_mismatch(inputs)
});